import Table from "../../../components/stateful/table/Table";
import CustomDialog from "../../../components/stateless/dialog/CustomDialog";
import HtmlRender from "../../../components/stateless/htmlRender/HtmlRender";
import PrivatePageLayout from "../../../layout/privatePageLayout/PrivatePageLayout";
import { useHistoricalDraftsController } from "./HistoricalDraftsController";

function HistoricalDrafts(props: any) {
  const {
    values,
    columnData,
    loading,
    handleDraftSelect,
    previewDialogOpen,
    togglePreviewDialog,
    draftPreview,
  } = useHistoricalDraftsController(props);

  const renderHistoricalDrafts = () => {
    return (
      <div>
        <Table
          values={values}
          columns={columnData}
          height="83svh"
          tableName="Historical Drafts"
          isLoading={loading}
          onRowClick={(e) => {handleDraftSelect(e.dataItem.id)}}
        />
        <CustomDialog
          open={previewDialogOpen}
          title={"Historical Draft Preview"}
          toggleDialog={togglePreviewDialog}
          hideButtons
          size="large"
        >
          {!!draftPreview && (
            <HtmlRender value={draftPreview} />
          )}
        </CustomDialog>
      </div>
    )
  }

  return (
    <PrivatePageLayout>
      {renderHistoricalDrafts()}
    </PrivatePageLayout>
  )
}

export default HistoricalDrafts;